var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-80",
    transform: "translate(-171 -211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83260",
    "data-name": "Path 83260",
    d: "M40,0C71.046,0,80,8.954,80,40S71.046,80,40,80,0,71.046,0,40,8.954,0,40,0Z",
    transform: "translate(171 211)",
    fill: "#ffe532"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83261",
    "data-name": "Path 83261",
    d: "M-20697.734-21422.744a2.99,2.99,0,0,1-2.121-.879l-8.65-8.65a3,3,0,0,1,0-4.242,3,3,0,0,1,4.242,0l6.529,6.529,19.625-19.623a3,3,0,0,1,4.242,0,3,3,0,0,1,0,4.242l-21.746,21.744A2.99,2.99,0,0,1-20697.734-21422.744Z",
    transform: "translate(20903.885 21687.988)",
    fill: "#1c2023"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckYellowIcon);
export default __webpack_public_path__ + "static/media/check_yellow_icon.429d316e9682a68cea1eefdb13d7cd53.svg";
export { ForwardRef as ReactComponent };